import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { ProductionPlansAndSpecifics } from './ProductionPlansAndSpecifics';
import { prefix, PRODUCTION_NAMES } from './utils/form';

export const ProductionSection: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_BUSINESS_OPERATIONS.PRODUCTION,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.production.title')}
          section={FOR_BANK_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.7.1 */}
      <ProductionPlansAndSpecifics disabled={!canAccess} />
      {/* 6.7.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.specifics')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.7.3 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.package')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.PACKAGE)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.PACKAGE)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.PACKAGE)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.7.4 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.inventoryManagement')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.INVENTORY_MANAGEMENT)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.INVENTORY_MANAGEMENT)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.INVENTORY_MANAGEMENT)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.7.5 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.outsourcingOpportunities')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.7.6 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.involvedProduction')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.INVOLVED_PRODUCTION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.INVOLVED_PRODUCTION)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.INVOLVED_PRODUCTION)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.7.7 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.disposalWaist')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.DISPOSAL_WAIST)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.DISPOSAL_WAIST)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.DISPOSAL_WAIST)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
    </>
  );
};
